import React, { useEffect, useState } from 'react';
import './components.scss';

const genText = (text, index) => {
  const Positions = [
    [25, 98],
    [55, 52],
    [147, 19.5],
    [235, 52],
    [268, 98],
  ];
  const getX = () => String(Positions[index][0]);
  const getYSingle = () => String(Positions[index][1]);
  const getYDouble = (seq) => String(Positions[index][1] - 7.5 + 15 * seq);

  if (text.split(' ').length === 1) {
    return (
      <tspan x={getX()} y={getYSingle()} textAnchor="middle">
        {text}
      </tspan>
    );
  }

  if (text.split(' ').length === 2) {
    const [text0, text1] = text.split(' ');
    return (
      <>
        <tspan x={getX()} y={getYDouble(0)} textAnchor="middle">
          {text0}
        </tspan>
        <tspan x={getX()} y={getYDouble(1)} textAnchor="middle">
          {text1}
        </tspan>
      </>
    );
  }
};

// const DefaultTexts = props.options.extremeTexts[
//   'Very Unlikely',
//   'Unlikely',
//   'Somewhat Unlikely',
//   'Likely',
//   'Very Likely',
// ];

const LikelihoodPannel = ({
  level = 1,
  // levelTexts = DefaultTexts,
  sequenceNumber,
  options,
  changeAnswerValue = () => {},
  optionsCount = 5,
  ...rest
}) => {
  const levelTexts =
    options.extremeTexts ||
    (options.radioText || options).map((itm) => itm?.text || '');
  const getPointerTrans = (l) =>
    `translate(140, 86) rotate(${l * 36 - 108 - Math.abs(l - 3) * 2} ,8, 38)`;

  let pointer, activeText, activeBlock;
  const ActiveColor = '#FFB600';
  const InactiveTextColor = '#ACACAC';
  const InactiveBlockColor = '#2C2C2C';

  const getElems = (l) => {
    pointer = document.querySelector(`#likelihood-pointer-${sequenceNumber}`);

    activeText = document.querySelector(`#level-${l}-text-${sequenceNumber}`);
    activeBlock = document.querySelector(`#path-level-${l}-${sequenceNumber}`);
  };

  const switchByLevel = (l) => {
    pointer.setAttribute('transform', getPointerTrans(l));
    activeText.setAttribute('fill', ActiveColor);
    activeBlock.setAttribute('fill', ActiveColor);
  };

  const clearActive = () => {
    activeText.setAttribute('fill', InactiveTextColor);
    activeBlock.setAttribute('fill', InactiveBlockColor);
  };

  const textsToRender = levelTexts.map(genText);

  const [newLevel, setNewLevel] = useState(level);

  useEffect(() => {
    setNewLevel(level);
  }, [level]);

  useEffect(() => {
    getElems(newLevel);
    if (parseInt(newLevel) === newLevel && newLevel >= 0 && newLevel <= 4) {
      switchByLevel(newLevel);
      return () => clearActive();
    }
    return () => {};
  }, [newLevel]);

  const onClickLevelPath = (levelNo) => () => {
    // if (!pointer || !activeBlock || !activeText) {
    //   getElems(newLevel);
    // }
    // clearActive();
    if (optionsCount === 3 && levelNo % 2 > 0) {
      return;
    }
    setNewLevel(levelNo);
    // getElems(levelNo);
    // switchByLevel(levelNo);
    changeAnswerValue(levelNo + 1);
  };

  return (
    <div className="complexity-svg-wrapper">
      <svg
        id={`likelihood-pannel-${sequenceNumber}`}
        width="21rem"
        height="8.563rem"
        viewBox="0 0 283 137"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Sample-Deal-Complexity-Strategy-complexity-detail(2)"
            transform="translate(-155.000000, -488.000000)"
          >
            <g id="group-2" transform="translate(155.000000, 488.000000)">
              <path
                d="M57,131 L71,131 C71,114.606582 75.7627278,99.3919145 85.2881835,85.3559989 C79.0194763,80.7972373 78.218278,80.2107761 73.9619456,77.1270054 C62.800793,92.5961016 57.1468111,110.553766 57,131 Z"
                id={`path-level-0-${sequenceNumber}`}
                stroke="#666666"
                fill="#2C2C2C"
                onClick={onClickLevelPath(0)}
                style={{ cursor: 'pointer' }}
              />
              <g
                id={`likelihood-pointer-${sequenceNumber}`}
                transform="translate(140.000000, 86.000000)"
              >
                <path
                  d="M21.5,-3 C21.7794469,-3 22.0091817,-2.77963813 22.0208153,-2.50043346 L23.8959236,42.5021673 C23.9510583,43.8253994 22.9230622,44.9427864 21.5998302,44.9979211 C21.5665715,44.9993069 21.5332875,45 21.5,45 C20.1756198,45 19.1019975,43.9263777 19.1019975,42.6019975 C19.1019975,42.5687099 19.1026906,42.535426 19.1040764,42.5021673 L20.9791847,-2.50043346 C20.9908183,-2.77963813 21.2205531,-3 21.5,-3 Z"
                  id="Rectangle-23"
                  fill="#ACACAC"
                  transform="translate(21.500000, 21.000000) rotate(39.000000) translate(-21.500000, -21.000000) "
                />
                <circle
                  id="Oval-12"
                  stroke="#ACACAC"
                  strokeWidth="2"
                  fill="#121212"
                  cx="8"
                  cy="38"
                  r="7"
                />
              </g>
              <path
                d="M86.9517867,90.632961 L100.951787,90.632961 C101.069979,75.2308561 105.929051,60.1314026 115.529003,45.3346003 C109.260296,40.7758387 108.428155,40.2321561 104.171822,37.1483854 C93.0106698,52.6174816 87.2706579,70.4456735 86.9517867,90.632961 Z"
                id={`path-level-1-${sequenceNumber}`}
                stroke="#666666"
                fill="#2C2C2C"
                transform="translate(101.240395, 63.890673) rotate(36.000000) translate(-101.240395, -63.890673) "
                onClick={onClickLevelPath(1)}
                style={{ cursor: 'pointer' }}
              />
              <path
                d="M134.905773,75.8210004 L148.905773,75.8210004 C148.628784,60.5268118 153.290266,45.4813163 162.890218,30.684514 C156.621511,26.1257524 155.930765,25.4436273 151.674433,22.3598565 C140.366917,37.5797515 134.777364,55.4001328 134.905773,75.8210004 Z"
                id={`path-level-2-${sequenceNumber}`}
                stroke="#666666"
                fill="#2C2C2C"
                transform="translate(148.896914, 49.090428) rotate(72.000000) translate(-148.896914, -49.090428) "
                onClick={onClickLevelPath(2)}
                style={{ cursor: 'pointer' }}
              />
              <text
                id={`level-2-text-${sequenceNumber}`}
                fontFamily="HelveticaNeue-Medium, Helvetica Neue, Arial"
                fontSize="12"
                fontWeight="400"
                fill="#ACACAC"
              >
                {textsToRender[2]}
              </text>
              <text
                id={`level-1-text-${sequenceNumber}`}
                fontFamily="HelveticaNeue-Medium, Helvetica Neue, Arial"
                fontSize="12"
                fontWeight="400"
                fill="#ACACAC"
              >
                {textsToRender[1]}
              </text>
              <text
                id={`level-3-text-${sequenceNumber}`}
                fontFamily="HelveticaNeue-Medium, Helvetica Neue, Arial"
                fontSize="12"
                fontWeight="400"
                fill="#ACACAC"
              >
                {textsToRender[3]}
              </text>
              <text
                id={`level-0-text-${sequenceNumber}`}
                fontFamily="HelveticaNeue-Medium, Helvetica Neue, Arial"
                fontSize="12"
                fontWeight="400"
                fill="#ACACAC"
              >
                {textsToRender[0]}
              </text>
              <text
                id={`level-4-text-${sequenceNumber}`}
                fontFamily="HelveticaNeue-Medium, Helvetica Neue, Arial"
                fontSize="12"
                fontWeight="400"
                fill="#ACACAC"
              >
                {textsToRender[4]}
              </text>
              <path
                d="M181.908146,91.9477335 L195.908146,91.9477335 C195.834247,76.508211 200.597273,61.3900486 210.197225,46.5932463 C203.928518,42.0344847 203.211206,41.3598175 198.954874,38.2760467 C187.793721,53.745143 182.111478,71.6357052 181.908146,91.9477335 Z"
                id={`path-level-3-${sequenceNumber}`}
                stroke="#666666"
                fill="#2C2C2C"
                transform="translate(196.052686, 65.111890) rotate(108.000000) translate(-196.052686, -65.111890) "
                onClick={onClickLevelPath(3)}
                style={{ cursor: 'pointer' }}
              />
              <path
                d="M211,132.408737 L225,132.408737 C224.62599,116.694736 229.238961,101.439335 238.838913,86.6425323 C232.570206,82.0837708 232.570206,82.0837708 228.313873,79 C217.152721,94.4690962 211.38143,112.272009 211,132.408737 Z"
                id={`path-level-4-${sequenceNumber}`}
                stroke="#666666"
                fill="#2C2C2C"
                transform="translate(224.919456, 105.704369) rotate(144.000000) translate(-224.919456, -105.704369) "
                onClick={onClickLevelPath(4)}
                style={{ cursor: 'pointer' }}
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

const calcComplexityOfFunctions = (answerArr) => {
  const isAboveMedium = (e) => parseInt(e, 10) > 1;
  const amountAboveMedium = answerArr.filter(isAboveMedium).length;
  if (amountAboveMedium > 3) {
    return 'high';
  }
  if (amountAboveMedium > 2) {
    return 'medium';
  }
  return 'low';
};

export const ThreeLevelPannel = (props) => {
  const { answer } = props;
  return (
    <LikelihoodPannel
      {...props}
      level={2 * (parseInt(answer, 10) - 1)}
      optionsCount={3}
    />
  );
};

export const LevelPannels = (props) => {
  const { answer, changeAnswerValue } = props;
  const onEachChange = (idx) => (e) => {
    const newAnswer = [
      ...answer.slice(0, idx),
      String(Math.ceil(e / 2)),
      ...answer.slice(idx + 1, 5),
    ];
    changeAnswerValue(calcComplexityOfFunctions(newAnswer), [...newAnswer]);
  };

  return (
    <div className="level-pannels-group">
      {(answer || []).map((e, idx) => {
        const options = [
          props.options[idx].options[0],
          null,
          props.options[idx].options[1],
          null,
          props.options[idx].options[2],
        ];

        return (
          <div className="pannel-and-title" key={`${idx}-${e}`}>
            <ThreeLevelPannel
              {...props}
              options={options}
              sequenceNumber={idx + 1000}
              answer={e}
              changeAnswerValue={onEachChange(idx)}
            />
            <div className="pannel-title">
              {props.options[idx]?.section || ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const ThreeLevelImportancePannel = (props) => {
  const texts = [
    {
      text: 'This deal will be supported by resources with other primary responsibilities',
    },
    {
      text: 'The deal will be mostly supported with non dedicated resources',
    },
    {
      text: 'The deal will be supported by both dedicated and non dedicated resources',
    },
    {
      text: 'The deal will be supported by dedicated resources',
    },
    {
      text: 'The deal will be supported by a dedicated M&A Integration team',
    },
  ];

  const onClickEachText = (idx) => () => {
    props.changeAnswerValue(idx + 1);
  };

  return (
    <div className="likelihood-pannel-hmml-wrapper">
      {texts.map((item, idx) => (
        <div
          className={`text-outside text-outside-${idx} ${
            props.level === idx ? 'active' : ''
          }`}
          key={`text-${idx}`}
          onClick={onClickEachText(idx)}
        >
          {item.text}
        </div>
      ))}
      <LikelihoodPannel {...props} options={texts} />
    </div>
  );
};

export default LikelihoodPannel;
